import { ApiConnector, DELETE, GET, POST, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/group');
    const APIV2 = ApiConnector('/group', true);
    return {
        GroupsList: async (data, query) => await APIV2(GET, 's', false, query).call(data),
        GroupsListSelect: async (data, query) => await API(GET, 's/select', false, query).call(data),
        SingleGroup: async (data, query) => await API(GET, 's/single', false, query).call(data),
        AddGroup: async (data, query) => await APIV2(POST, 's', false, query).call(data, true),
        getPupilsOfGroups: async (data, query, params) =>
            await APIV2(GET, `s/${params.group_id}/students`, false, query).call(data),
        EditGroup: async (data, query) => await APIV2(PUT, 's', false, query).call(data, true),
        DeleteGroup: async (data, query) => await API(DELETE, 's', false, query).call(data),
        InitGroupHW: async (data, query) => await API(POST, '/init-hw', false, query).call(data),
        simpleGetStudent: async (data, query, params) =>
            await API(GET, `s/${params.group_id}/students/reduced`, false, query).call(data),
        getGroupHistory: async (data, query) => await API(GET, `/history`, false, query).call(data),
        getGroupHistoryHw: async (data, query) => await API(GET, `/history/hw`, false, query).call(data),
        GetGroupsByOffice: async query => await API(GET, '/school', false, query).call(),
        ChangeEqualizerState: async data => await API(POST, '/equealizer').call(data),
        GetGroupsByFilters: async query => await APIV2(GET, 's/school', false, query).call(),
        GetCandidateStudent: async (data, query, params) =>
            await APIV2(GET, `s/${params.group_id}/candidate`, false, query).call(data),
    };
})();
